import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class NotificationService {
  public oLogUser = JSON.parse(sessionStorage.getItem("Gesteam_User"));

  // constructor(
  //   private _incidents: IncidentsService,
  //   private _documents: DocumentsService
  // ) {}

  // get() {
  //   if (this.oLogUser != null) {
  //     this._incidents.get(
  //       this.oLogUser.service_ID,
  //       this.oLogUser.installation_ID,
  //       "",
  //       "",
  //       0
  //     );
  //     this._documents.get();
  //   }
  // }

  // getNewIncidents(): Observable<any[]> {
  //   return this._incidents.incidents$;
  // }

  // getNewDocuments(): SalDoc[] {
  //   return this._documents.docs.filter(
  //     (element: SalDoc) => element.salDoc_Statut == 0
  //   );
  // }
}
